<div id="form-container">
  <div class="mb-3">
    <label class="mb-1" for="hour-select"><strong>Hour</strong></label>
    <select
      id="hour-select"
      class="form-control"
      name="hour"
      [(ngModel)]="selectedHour"
      (ngModelChange)="onHourChanged($event)"
    >
      @for (hour of hourOptions; track hour.value) {
        <option [ngValue]="hour.value">{{ hour.label }}</option>
      }
    </select>
  </div>
  <div class="mb-3">
    <div class="mb-1"><strong>Day</strong></div>
    <bs5-unix-cron
      name="cron"
      [(ngModel)]="value"
      [tabs]="cronTabs"
      [activeTab]="activeCronTab"
      [hideTabs]="true"
      (tabChanged)="activeCronTab = $event"
      (changed)="onCronChanged($event)"
    ></bs5-unix-cron>
  </div>
  <input class="form-control" readonly [value]="value" />
  @if (validationError) {
    <div class="text-danger mt-2">{{ validationError }}</div>
  }
  <div class="mt-3">
    <label class="mb-1" for="timezone-select"><strong>Timezone*</strong></label>
    <ng-select
      id="timezone-select"
      name="timezone"
      [items]="timezones"
      bindLabel="label"
      bindValue="value"
      [(ngModel)]="selectedTimezone"
      [clearable]="false"
      [searchable]="true"
      required
      placeholder="Select timezone"
    ></ng-select>
  </div>
  <div class="mt-2 text-muted small">**Minimum interval is 24 hours.</div>
</div>
<div class="modal-footer justify-content-center">
  <button type="button" class="btn btn-yellow w-132" (click)="confirm()">Confirm</button>
  <button type="button" class="btn btn-yellow w-132" (click)="disableAutomation()">
    Disable Schedule
  </button>
  <button type="button" class="btn btn-danger w-132" (click)="close()">Cancel</button>
</div>
